import { AxiosResponse } from 'axios';

import {
  IGetAttributesResponse,
  IGetAttributesSimpleListResponse,
  ICreateAttributeRequestBody,
  ICreateAttributeResponse,
  IUpdateAttributeRequestBody,
  IUpdateAttributeResponse,
  IDeleteAttributesResponse,
  IDeleteAttributesReqestFilters,
  IGetSingleAttributeResponse,
  IGetAttributesRequestFilters,
} from 'models/http/attributes';
import { IGetHistoryResponse } from 'models/http/history';

import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { DataUploadModels, ModelsNames } from 'utils/enums/model-names';
import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from '../../http';
import { HTTP } from './core.http';
import DataUploadBaseHttp from './utils/data-upload.http';
import { IGetSimpleListFilters } from 'models/http/common';

class AttributeHttp extends DataUploadBaseHttp implements HTTP<IDeleteAttributesReqestFilters> {
  public static DataExportRoute = `${ModelsNames.Attributes}/data-export`;
  protected route: DataUploadModels = ModelsNames.Attributes;

  public async history(id: string, abortController?: AbortController): Promise<IGetHistoryResponse> {
    return serverAxios
      .get(`/${this.route}/${id}/history`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Highest,
      })
      .then((response: AxiosResponse<IGetHistoryResponse>) => response.data);
  }

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetAttributesSimpleListResponse> {
    return serverAxios
      .get(`/${this.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetAttributesSimpleListResponse>) => {
        return response.data;
      });
  }

  public async get(filters?: IGetAttributesRequestFilters, abortController?: AbortController): Promise<IGetAttributesResponse['records']> {
    const queryParams = prepareQPFromFilters(filters || {});

    return serverAxios
      .get(`/${this.route}?${queryParams.toString()}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetAttributesResponse>) => {
        return response.data.records;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSingleAttributeResponse> {
    return serverAxios
      .get(`/${this.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSingleAttributeResponse>) => {
        return response.data;
      });
  }

  public async create(data: ICreateAttributeRequestBody): Promise<ICreateAttributeResponse> {
    return serverAxios
      .post(`/${this.route}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateAttributeResponse>) => {
        return response.data;
      });
  }

  public async update(id: number, data: IUpdateAttributeRequestBody): Promise<IUpdateAttributeResponse> {
    return serverAxios
      .put(`/${this.route}/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IUpdateAttributeResponse>) => {
        return response.data;
      });
  }

  public async delete(ids: number[]): Promise<IDeleteAttributesResponse>;
  public async delete(filters: IDeleteAttributesReqestFilters): Promise<IDeleteAttributesResponse>;
  public async delete(filters: number[] | IDeleteAttributesReqestFilters): Promise<IDeleteAttributesResponse> {
    return serverAxios
      .delete(`/${this.route}`, {
        data: prepareFiltersOfSelection(filters),
      })
      .then((response: AxiosResponse<IDeleteAttributesResponse>) => {
        return response.data;
      });
  }
}

export default AttributeHttp;
